/**
 * defa.collections.PhoneNumbers
 * A collection of PhoneNumber models.
 * @version 1.2.0
 */
import PhoneNumber from 'scripts/defa/phone-numbers/model-phone-number';

const PhoneNumbers = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: PhoneNumber,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default PhoneNumbers;